import { Dispatch } from 'redux';
import Axios from "axios";
import {
  FETCH_DOCUMENT_DELIVERY_FORMATS_START,
  FETCH_DOCUMENT_DELIVERY_FORMATS_SUCCESS,
  FETCH_DOCUMENT_DELIVERY_FORMATS_FAIL,
} from "src/actionTypes";
import { axiosHeaders } from "src/utils/helpers";

const fetchDocumentDeliveryFormatsStart = () => {
  return {
    type: FETCH_DOCUMENT_DELIVERY_FORMATS_START,
  };
};

const fetchDocumentDeliveryFormatsSuccess = (deliveryFormats: Record<string, any>[]) => {
  return {
    type: FETCH_DOCUMENT_DELIVERY_FORMATS_SUCCESS,
    payload: deliveryFormats,
  };
};

const fetchDocumentDeliveryFormatsFail = () => {
  return {
    type: FETCH_DOCUMENT_DELIVERY_FORMATS_FAIL,
  };
}

export const fetchDocumentDeliveryFormats = () => {
  return async (dispatch: Dispatch) => {
    dispatch(fetchDocumentDeliveryFormatsStart());
    try {
      const response = await Axios.get(
        `${window.config.backend.procys_service}v1/integrations/email/deliver/format`,
        axiosHeaders(localStorage.getItem('PROCYS_accessToken'))
      );
      if (response?.data.success) {
        dispatch(fetchDocumentDeliveryFormatsSuccess(response.data.data));
      } else {
        dispatch(fetchDocumentDeliveryFormatsFail());
      }
    }
    catch (error) {
      dispatch(fetchDocumentDeliveryFormatsFail());
    }
  };
};
